<div class="form-group btn-group w-100" role="group">
  @for (tab of SimpleEscalatedUpsertTab | enumOptions; track tab.value) {
    <input type="radio" class="btn-check" [id]="tab.value" [value]="tab.value" [formControl]="formGroup.controls.selectedTabControl" />
    <label class="btn btn-outline-primary" [for]="tab.value">{{tab.value | messageTranslate}}</label>
  }
</div>

@if (formGroup.controls.selectedTabControl.value === SimpleEscalatedUpsertTab.ASSIGN) {
  <div class="form-group">
    <label class="form-label" for="assignTo">{{'Assign to' | messageTranslate}}</label>
    <app-ace-select id="assignTo"
                    bindLabel="fullName"
                    bindValue="id"
                    [formControl]="formGroup.controls.assigneeId"
                    [clearable]="false"
                    [groupBy]="groupByFn"
                    [items]="assigneeOptions"
                    [loading]="assigneesLoading"/>
    <app-errors [control]="formGroup.controls.assigneeId" [translatedErrorMessagesByType]="assigneeErrorMessages"/>
  </div>
}

@if (formGroup.controls.selectedTabControl.value === SimpleEscalatedUpsertTab.RESOLVE) {
  <div class="form-group">
    <label class="form-label" for="status">{{'Status' | messageTranslate}}</label>
    <app-ace-select id="status"
                    bindValue="status_id"
                    bindLabel="display_text"
                    [formControl]="formGroup.controls.statusId"
                    [clearable]="false"
                    [placeholder]="'Select Status' | messageTranslate"
                    [items]="statusOptions"/>
    <app-errors [control]="formGroup.controls.statusId"/>
  </div>
}

<div class="form-group">
  <label class="form-label" for="comment">{{'Add comment (optional)' | messageTranslate}}</label>
  <textarea #commentBox
            id="comment"
            class="form-control"
            appCommentMention
            [mentionListTemplate]="mentionItemTemplate"
            [assigneesByEntityName]="assigneesByEntityName"
            [mentionsLoading]="assigneesLoading"
            [formControl]="formGroup.controls.comment"
            (focus)="onCommentBoxFocus(true)"
            (blur)="onCommentBoxFocus(false)"></textarea>
  @if (commentBoxFocused || hasCommentText || mentionLastFocused) {
    <div class="mt-2 d-inline-block">
      @if (isMobile) {
        <select class="form-select mention"
                [formControl]="mobileMentionControl"
                (focus)="updateMentionLastFocus(true)"
                (blur)="updateMentionLastFocus(false)">
          <option [ngValue]="null" disabled hidden="hidden" selected>{{'Mention' | messageTranslate}}</option>
          @if (assigneesLoading) {
            <option disabled>{{'Loading...' | messageTranslate}}</option>
          }
          @for (entry of assigneesByEntityName | keyvalue; track entry.key) {
            <optgroup [label]="entry.key">
              @for (assignee of entry.value; track assignee.id) {
                <option [ngValue]="assignee">{{assignee.fullName}}</option>
              }
            </optgroup>
          }
        </select>
      } @else {
        <div class="mention" ngbDropdown appLastClickInside (lastClickInsideChange)="updateMentionLastFocus($event)">
          <button type="button" class="btn btn-secondary" ngbDropdownToggle>
            {{('Symbol Mention' | messageTranslate:{symbol: MENTION_CHARACTER})}}
          </button>
          <div ngbDropdownMenu>
            @if (assigneesLoading) {
              <div class="text-center">
                <fa-icon [appShowFaSpinner]="true"/>
              </div>
            }
            @for (entry of assigneesByEntityName | keyvalue; track entry.key) {
              <div class="py-2 px-3 text-truncate text-body-secondary" ngbdropdownitem>{{entry.key}}</div>
              @for (assignee of entry.value; track assignee.id) {
                <button type="button"
                        class="py-2 px-4 text-truncate"
                        ngbDropdownItem
                        (click)="addMention(assignee)">
                  {{assignee.fullName}}
                </button>
              }
            }
          </div>
        </div>
      }
    </div>
  }
</div>
<ng-template #mentionItemTemplate let-item="item">
  @if (item.isSpinner) {
    <div class="px-2 py-2 text-center" (mousedown)="mentionItemClickHandler(item, $event)">
      <fa-icon [appShowFaSpinner]="true"/>
    </div>
  } @else {
    <div [title]="item.label"
         [class]="'py-2 text-truncate ' + (item.isGroup ? 'px-3 bg-white text-body-secondary is-group' : 'clickable px-4')"
         (mousedown)="mentionItemClickHandler(item, $event)">
      {{item.label}}
    </div>
  }
</ng-template>
